export default "/fcbcac1db17390110677298f9d30eeed9c121039/2cb37da391587709fd85749e116baa74.svg";